module.exports = __webpack_public_path__ + "media/application/images/icons/info-05fb889954a0e27683264db568fb87fa.svg";